import { useContext, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Dropdown } from "react-bootstrap";
import { FaEllipsisV } from "react-icons/fa";
import { request } from "../../../utils/api";
import { toast } from "react-toastify";
import { formatYYYYMMDD } from "../../../utils";
import Loading from "../utilComponent/Loading";
import DeleteModal from "../modal/DeleteModal";
import ViewUserModal from "../modal/ViewUserModal";
import Pagination from "../utilComponent/Pagination";
import { AbilityContext } from "../../../context/AbilityContext";

const WearhouseList = () => {
  const navigate = useNavigate();
  const ability = useContext(AbilityContext);
  const [showViewModal, setShowViewModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedWearhouse, setSelectedWearhouse] = useState(null);
  const [searchText, setSearchText] = useState("");
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({
    current_page: 1,
    per_page: 15,
    total: 0,
    last_page: 1,
  });
  const [wearhouse, setWearhouse] = useState([]);
  
  const getTableData = async (page = 1) => {
    try {
      setLoading(true);
      const response = await request({
        url: `warehouses?page=${page}&per_page=${pagination.per_page}`,
        method: "GET",
      });

      if (response.status && response.data) {
        setWearhouse(
          response.data.items.map((item) => ({
            id: item.id,
            name: item.name,
            address: item.address,
            user_qty: item.users?.length || 0,
            created_at: item.created_at,
          }))
        );
        setPagination(response.data.pagination);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getTableData(pagination.current_page);
  }, []);

  const handlePageChange = (page) => {
    setPagination({ ...pagination, current_page: page });
    getTableData(page);
  };

  const filteredWearhouse = wearhouse.filter((item) =>
    Object.values(item).some((v) =>
      String(v).toLowerCase().includes(searchText.toLowerCase())
    )
  );

  const redirectWarehouse = (item) =>{
    navigate(`/warehouse-products/${item.id}`);
  }

  return (
    <div>
      <ViewUserModal
        show={showViewModal}
        onClose={() => setShowViewModal(false)}
        data={selectedWearhouse}
        fields={[
          { label: "Name", key: "name" },
          { label: "Address", key: "address" },
          { label: "User QTY", key: "user_qty" },
          { label: "Created Date", key: "created_at" },
        ]}
        title="Warehouse Details"
        onEdit={(item) => navigate(`/warehouse-update/${item.id}`)}
      />

      <DeleteModal
        show={showDeleteModal}
        onClose={() => setShowDeleteModal(false)}
        onConfirm={async () => {
          await request({
            url: `warehouses/${selectedWearhouse?.id}`,
            method: "DELETE",
          });
          toast.success("Warehouse deleted successfully");
          setShowDeleteModal(false);
          getTableData(pagination.current_page);
        }}
      />

      <div className="page-toolbar px-xl-4 px-sm-2 px-0 py-3">
        <div className="container-fluid">
          <ol className="breadcrumb bg-transparent mb-0">
            <li className="breadcrumb-item">
              <Link className="text-secondary" to="/">
                Home
              </Link>
            </li>
            <li className="breadcrumb-item active">Warehouse List</li>
          </ol>
        </div>
      </div>

      <div className="page-body px-xl-4 px-sm-2 px-0 py-3">
        <div className="container-fluid">
          <div className="card shadow-sm">
            <div className="card-body">
              <div className="d-flex justify-content-between mb-3">
                <input
                  className="form-control w-50"
                  placeholder="Search warehouse..."
                  onChange={(e) => setSearchText(e.target.value)}
                />
                {/* <Button variant="danger">
                  <FaFilePdf className="me-1" /> Export PDF
                </Button> */}
              </div> 

              {loading ? (
                <Loading />
              ) : (
                <div className="row">
                  {filteredWearhouse.length ? (
                    filteredWearhouse.map((item) => (
                      <div className="col-xl-4 col-lg-6 mb-4" key={item.id}>
                        <div className="card h-100 shadow-sm">
                          <div className="card-body">
                            <div className="d-flex justify-content-between">
                              <h6 className="fw-bold" style={{textDecoration:'underline', cursor:"pointer"}} onClick={()=>redirectWarehouse(item)}>{item.name}</h6>

                              <Dropdown align="end">
                                <Dropdown.Toggle
                                  variant="light"
                                  className="border-0 p-0"
                                >
                                  <FaEllipsisV />
                                </Dropdown.Toggle>

                                <Dropdown.Menu>
                                  {ability.can('viewWarehouse', 'all') &&  <Dropdown.Item
                                    onClick={() => {
                                      setSelectedWearhouse(item);
                                      setShowViewModal(true);
                                    }}
                                  >
                                    View
                                  </Dropdown.Item>}

                                 {ability.can('updateWarehouse', 'all') && <Dropdown.Item
                                    onClick={() =>
                                      navigate(`/warehouse-update/${item.id}`)
                                    }
                                  >
                                    Edit
                                  </Dropdown.Item>}

                                 {ability.can('deleteWarehouse', 'all') &&  <Dropdown.Item
                                    className="text-danger"
                                    onClick={() => {
                                      setSelectedWearhouse(item);
                                      setShowDeleteModal(true);
                                    }}
                                  >
                                    Delete
                                  </Dropdown.Item>}
                                </Dropdown.Menu>
                              </Dropdown>
                            </div>

                            <p className="text-muted mb-1">📍 {item.address}</p>
                            <p className="mb-1">
                              👥 Users: <strong>{item.user_qty}</strong>
                            </p>
                            <small className="text-muted">
                              Created: {formatYYYYMMDD(item.created_at)}
                            </small>
                          </div>
                        </div>
                      </div>
                    ))
                  ) : (
                    <div className="text-center py-5">No warehouse found</div>
                  )}
                </div>
              )}

            <Pagination
                currentPage={pagination.current_page}
                lastPage={pagination.last_page}
                onPageChange={handlePageChange}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WearhouseList;
